<template>
  <div>
    <vx-card title="Groups">
      <a-button @click="addPermission" type="primary" class="font-normal mb-4 float-right" style="border-radius: 3px !important;">Add</a-button>
      <XTable :model="model" ref="permission" :is_pagenation="false" :search="false" method="get" class="clear-both">
        <span slot="act" slot-scope="text,record">
          <feather-icon svg-classes="w-5 h-5 text-danger" icon="TrashIcon" class="cursor-pointer" @click="openDeletePermission(text.record.id)"></feather-icon>
          <feather-icon svg-classes="w-5 h-5 text-success ml-2" icon="EditIcon" class="cursor-pointer" @click="editGroup(text.record)"></feather-icon>
        </span>
        <span slot="lawyer_user" slot-scope="text,record">
          <ATag v-for="item in text.record.users">
            <span>{{ item.first_name }} {{ item.last_name }}</span>
<!--            <small>{{ item.email_address }}</small>-->
          </ATag>
        </span>
      </XTable>
    </vx-card>
    <a-modal
      v-model="activePrompt"
      title="Groups"
      @cancel="activePrompt = false"
    >
      <a-form :form="form" @submit.prevent="handlerGroup">
       <a-form-item title="Title" has-feedback>
         <a-input
           placeholder="Permission"
           v-decorator="['title',{ rules: [{ required: true, message: 'this field is required.' }]}]"/>
       </a-form-item>
        <SelectOption
          url="/account/list/"
          label="Users"
          field="users"
          :required="false"
          method="get"
          mode="multiple"
          placeholder="Find A User"
          class="w-full mt-4"
        />
        <a-button
          type="primary"
          class="w-full mt-4"
          html-type="submit"
          :loading="loading"
        >
          Save
        </a-button>
      </a-form>
    </a-modal>
    <vs-prompt
      id="groupDelete"
      color="danger"
      title="Delete Permission"
      @cancel="activePromptDelete = false"
      @close="activePromptDelete = false"
      :active.sync="activePromptDelete"
      buttons-hidden
    >
      <div class="text-center">
        <div class="font-medium">Are you sure to delete this Group?</div>
        <br>
        <vs-button color="danger" type="filled" @click="saveDelete">delete</vs-button>
        <vs-button color="danger" type="flat" @click="activePromptDelete = false">cancel</vs-button>
      </div>
    </vs-prompt>
  </div>

</template>

<script>
    import * as TableColPermission from "./pTbl";
    import * as TableCol from "./gTbl";
    import * as TableColTitle from "./jTbl";
    import XTable from "../../../../components/x-table/XTable";
    import axios from "@/axios"
    import SelectOption from "@/views/forms/SelectOptionSingle";
    import mixin from "@/views/mixin/mixin";

    export default {
        name: "GroupPermisionTitle",
        mixins:[mixin],
        components:{
          SelectOption,
          XTable
        },
        data(){
          return{
            model:null,
            modelpermission:null,
            modelTitle:null,
            activePrompt: false,
            activePromptDelete: false,
            rowId: null,
            loading: false,
            edit_mode: false
          }
        },
        methods:{
          addPermission(){
            this.activePrompt = true
            this.edit_mode = false
          },

          editGroup(item){
            this.activePrompt = true
            this.edit_mode = true
            this.rowId = item.id
            this.$nextTick(() => {
              this.form.setFieldsValue({ title: item.title, users: item.users.map(item => item.id) })
            })
          },

          async handlerGroup(){
            this.form.validateFields(async (err, values) => {
              if (!err) {
                try{
                  this.loading = true
                  if (this.edit_mode)
                    await axios.put(`/account/group/${this.rowId}/edit/`,values)
                  else
                    await axios.post('/account/group/',values)
                  this.activePrompt = false
                  this.form.resetFields()
                  await this.$refs.permission.fetch()
                }catch (e) {
                  this.$ntSetError(e.data)
                }finally {
                  this.loading = false
                }
              }
            })
          },

          async saveDelete(){
            try{
              this.$refs.permission.loading = true
              this.activePromptDelete = false
              const id = this.rowId
              await axios.delete(`/account/group/${id}/delete/`)
              await this.$refs.permission.fetch()
              this.$ntSet('deletion completed successfully.')
            }catch (e) {
              this.$ntSetError()
            }finally {
              this.activePromptDelete = false
              this.$refs.permission.loading = false
            }
          },

          openDeletePermission(id){
            this.rowId = id
            this.activePromptDelete = true
          },

        },
        created() {
          this.model = TableCol.default
          this.modelpermission = TableColPermission.default
          this.modelTitle = TableColTitle.default
        }
    }
</script>

<style>
  .con-exemple-prompt{
    padding: 10px;
    padding-bottom: 0px;
  }
  .vs-input{
    width: 100%;
    margin-top: 10px;
  }
  [dir] .vs-input--input.normal{
    padding: 0.5rem !important;
  }
  .con-vs-dialog .vs-dialog header span.after {
    width: 3px !important;
  }
  .con-vs-dialog .vs-dialog footer:before{
    background: none !important;
  }
</style>
